import React, { Fragment, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import axios from "axios";
import Auth from "../auth/auth";
import authMethods from "../auth/auth";

import { API_URL_FAVORITES } from "../config/config";
import { PrefIcon } from "./iconlist.js";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LanguageContext } from "../containers/languageprovider";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import globalStyles from "./globalStyles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  buttonNoSelect: {
    margin: theme.spacing(1),
    borderRadius: "10px",

    BorderColor: "#5AC071",
    boxShadow: "none",
    border: "1px solid",
    //backgroundColor: "",
    color: "#5AC071",

    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",

    letterSpacing: "0.03em",
    fontVariant: "all-small-caps",
  },
  buttonSelect: {
    margin: theme.spacing(1),
    borderRadius: "10px",

    BorderColor: "#5AC071",
    boxShadow: "none",
    border: "1px solid",
    backgroundColor: "#5AC071",
    color: "white",
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",

    letterSpacing: "0.03em",
    fontVariant: "all-small-caps",
  },
  paper: {
    position: "absolute",
    //width: 400,
    backgroundColor: theme.palette.background.paper,
    //border: '2px solid #000',
    boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
  },
}));

export default function SwitchFavorites(props) {
  const globalClasses = globalStyles();
  const classes = useStyles();
  const [favoriteState, setfavoriteState] = React.useState(props.favoritesid);
  const [favoriteStateButton, setfavoriteStateButton] = React.useState(true);
  const { dictionary } = React.useContext(LanguageContext);
  const [open, setOpen] = React.useState(false);
  const [alertseverity, setAlertSeverity] = React.useState("success");
  const [alertmsg, setAlertMsg] = React.useState(false);
  const [hasBeenClicked, setHasBeenClicked] = React.useState(false)

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    if (!hasBeenClicked) {
    setfavoriteState(props.favoritesid);
    }
  }, [props]);





  const AddFavorite = () => {
    const token = authMethods.getToken();

    if (token === null) {
      setAlertMsg(dictionary.HelpFavorite );
      setAlertSeverity("info");
      setOpen(true);
      return;
    }

    setfavoriteStateButton(false);
    axios
      .put(API_URL_FAVORITES, {
        building_id: props.building_id,
      },{
        headers: {
          Authorization: "Bearer " + Auth.getToken(),
          "Content-Type": "application/json",
        },
      })
      .then((payload) => {
        setfavoriteState(payload.data.record.id);
        setfavoriteStateButton(true);
        setAlertMsg(dictionary.AddToFavorite);
        setAlertSeverity("success");
        setHasBeenClicked(true)
        setOpen(true);
        props.onChange(payload.data.record.id);
      });
  };
  const RemoveFavorite = () => {
    const token = Auth.getToken();
    setfavoriteStateButton(false);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;

    axios.delete(API_URL_FAVORITES + "/" + favoriteState).then((payload) => {
      setOpenDialog(false);
      setfavoriteState(null);
      setfavoriteStateButton(true);
      setAlertMsg(dictionary.RemoveFromFavorite);
      setHasBeenClicked(true)
      setAlertSeverity("success");
      setOpen(true);
      props.onChange(null);
    });
  };

  return (
    <Fragment>
      {props.type === "icon" ? (
        <Fragment>
          {favoriteState !== undefined && favoriteState !== null ? (
            <IconButton
              disabled={!favoriteStateButton}
              size="medium"
              style={{ backgroundColor: "#5AC071", padding: "8px" }}
              onClick={() => setOpenDialog(true)}
            >
              <PrefIcon fill={"white"} viewBox={"0 0 24 24"} />
            </IconButton>
          ) : (
            <IconButton
              disabled={!favoriteStateButton}
              size="medium"
              style={{ padding: "8px" }}
              onClick={AddFavorite}
            >
              <PrefIcon fill={"#5AC071"} viewBox={"0 0 24 24"} />
            </IconButton>
          )}
        </Fragment>
      ) : (
        <Fragment>
          {favoriteState !== undefined && favoriteState !== null ? (
            <Button
              disabled={!favoriteStateButton}
              variant="outlined"
              className={classes.buttonSelect}
              startIcon={<PrefIcon fill={"white"} viewBox={"0 0 24 24"} />}
              onClick={RemoveFavorite}
            >
              {dictionary.saveTooltip}
            </Button>
          ) : (
            <Button
              disabled={!favoriteStateButton}
              variant="outlined"
              className={classes.buttonNoSelect}
              startIcon={<PrefIcon fill={"#5AC071"} viewBox={"0 0 24 24"} />}
              onClick={AddFavorite}
            >
              {dictionary.saveTooltip}
            </Button>
          )}
        </Fragment>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.paper}>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={alertseverity}>
              {alertmsg}
            </Alert>
          </Snackbar>
        </div>
      </Modal>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle>{dictionary.ConfirmDeletePreference}</DialogTitle>
        <DialogContent style={{ maxWidth: "374px" }}>
          <DialogContentText>
            {dictionary.ConfirmDeletePreferenceInfo}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCloseDialog}
            color="primary"
            variant="outlined"
            className={globalClasses.buttonDialog}
          >
            {dictionary.cancelTooltip}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={globalClasses.buttonDialog}
            onClick={RemoveFavorite}
          >
            {dictionary.Continue}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
